import { NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import type { Currency } from '@recruitee/pricing-types';
import { BillingPlanTier } from '@recruitee/products-types';
import type { PaymentInterval } from '@recruitee/subscription-types';
import { DividerComponent, BadgeComponent, PlanButtonComponent } from '@recruitee/user-interface';

import { JobSlotsLimitMessageComponent } from '../../../job-slots-limit-message/job-slots-limit-message.component';
import { PlanPickerProductCtaLabelPipe } from '../../plan-picker-product-cta-label.pipe';
import { ProductStatus } from '../../plan-picker.types';
import { Product, Products, ViewMode } from '../plan-picker-2024.types';
import { PlanPicker2024ProductPriceComponent } from '../plan-picker-product-price/plan-picker-2024-product-price.component';

@Component({
  selector: 'rt-plan-picker-2024-products',
  templateUrl: './plan-picker-2024-products.component.html',
  styleUrls: ['./plan-picker-2024-products.component.less'],
  standalone: true,
  imports: [
    PlanPicker2024ProductPriceComponent,
    PlanButtonComponent,
    BadgeComponent,
    NgTemplateOutlet,
    JobSlotsLimitMessageComponent,
    DividerComponent,
    TranslatePipe,
    PlanPickerProductCtaLabelPipe,
  ],
})
export class PlanPicker2024ProductsComponent {
  @Input() public viewMode: ViewMode = ViewMode.Default;
  @Input() public interval: PaymentInterval;
  @Input() public currency: Currency;
  @Input() public products: Products;
  @Input() public showTrialBadge = false;
  @Input() public showSlotsLimitMessage = false;
  @Input() public startPlanSlotsLimit: number;

  @Output() public chooseProduct: EventEmitter<Product> = new EventEmitter();
  @Output() public cancelSubscription: EventEmitter<void> = new EventEmitter();

  public BillingPlanTier = BillingPlanTier;
  public ViewMode = ViewMode;
  protected readonly ProductStatus = ProductStatus;

  public isButtonDisabled(status: ProductStatus) {
    return status === ProductStatus.Owned || status === ProductStatus.ManualServiceOwned;
  }

  public showCancelSubscription(status: ProductStatus) {
    return status === ProductStatus.TierOwned || status === ProductStatus.Owned;
  }
}
